import { LuBan, LuHeart, LuShield } from 'react-icons/lu';
import { V2_TOKENS } from '../../tokens';
import styles from '../styles.module.scss';

const ITEMS = [
    {
        Icon: LuShield,
        title: '個人情報はしっかり保護',
        description: 'かんたん査定では名前・連絡先は\n一切不要です',
    },
    {
        Icon: LuBan,
        title: 'しつこい営業は一切なし',
        description: '査定結果を見た後も安心。\n勧誘やしつこい営業はしません',
    },
    {
        Icon: LuHeart,
        title: 'あなたのペースで大丈夫',
        description: 'まずは相場を知るだけでもOK。\nすべてあなたのタイミングで進められます',
    },
];

export const ReassureSection = () => {
    return (
        <section className={styles.reassureSection}>
            <h2 className={styles.sectionTitle}>安心してご利用いただけます</h2>

            <div className={styles.reassureRow}>
                {ITEMS.map((item) => {
                    const Icon = item.Icon;
                    return (
                        <div key={item.title} className={styles.reassureCard}>
                            <div className={styles.reassureIconCircle}>
                                <Icon size={18} color={V2_TOKENS.color.primary} />
                            </div>
                            <h3 className={styles.reassureTitle}>{item.title}</h3>
                            <p className={styles.reassureDesc}>{item.description}</p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};
